import { IonButton, IonContent, IonHeader, IonPage, IonTitle, IonToolbar, useIonRouter, useIonViewDidEnter } from '@ionic/react';
import React, { useEffect } from 'react';
import { useAppContext } from '../AppProvider';
import { Link } from 'react-router-dom';

const Connection: React.FC = () => {

    const { networkStatus, appStatus, authKey, setShowLoader } = useAppContext();  

    const router = useIonRouter();

    useIonViewDidEnter(() => { 
        setShowLoader(false);        
    }); 
    
    useEffect(() => {
        //console.log(networkStatus, appStatus, authKey);
        if (networkStatus && (appStatus === 'Fast' || appStatus === 'Slow') && Object.keys(authKey).length > 0) {
            //console.log('Re-connected');
            router.push('/account/dashboard', 'forward');
        } else setShowLoader(false);
    }, [networkStatus, appStatus, authKey]);    
    

    return (
        <IonPage>
            <IonHeader>
                <IonToolbar>
                    <IonTitle>SoloWise</IonTitle>
                </IonToolbar>
            </IonHeader>
            <IonContent className="ion-padding">
                <h1 className='ion-text-center'>No Connection</h1>
                
                <p className='ion-text-center'>
                    <IonButton className='ion-margin' fill='outline' routerLink={`/account/dashboard`} routerDirection='forward'>Try again</IonButton>
                </p>
            </IonContent>
        </IonPage>
    );
};

export default Connection;